<div class="mt-5 pt-5">
  <h3 class="mb-5">
    <span> {{ "profile" | translate }}</span>
  </h3>
  <div class="row mx-3">
    <app-user-data class="col-12 col-sm-3 p-0 p-sm-auto" />

    <div class="col-12 col-sm-9 right-card">
      <ng-container [ngSwitch]="component">
        <app-my-courses *ngSwitchCase="'myCourses'" />
        <app-my-payments *ngSwitchCase="'payments'" />
        <app-reset-password *ngSwitchCase="'reset-password'" />
      </ng-container>
    </div>
  </div>
</div>
